<nz-upload #uploader
           [nzShowButton]="canUpload$ | async"
           [nzAction]="uploadUrl"
           [nzType]="type$|async"
           [nzFileList]="files$ | async"
           [nzBeforeUpload]="beforeUpload"
           [nzMultiple]="multiple"
           [nzShowUploadList]="nzShowUploadList$ | async"
           [nzAccept]="accept$ | async"
           [nzRemove]="fileListRemove"
           [nzListType]="listType$ | async"
           [nzPreview]="handlePreview"
           [nzLimit]="limit"
           (nzChange)="uploadChange($event)"
           (nzFileListChange)="fileListChange($event)"
           [nzBeforeUpload]="beforeUpload">
  <div>
    <ng-container *ngIf=" (type$ | async) == 'drag'; else default">
      <p class="ant-upload-drag-icon">
        <i nz-icon nzType="inbox"></i>
      </p>
      <p class="ant-upload-text">{{resolveKey('ClickToUpload') | translate}}</p>
      <!-- <p class="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
      </p> -->
    </ng-container>
    <ng-template #default>
      <i nz-icon nzType="plus"></i>
      <div class="ant-upload-text">{{resolveKey('Upload') | translate}}</div>
    </ng-template>
  </div>
</nz-upload>
<!-- <div class="size-limit">附件最大为 {{attachmentSize/1024/1024}}MB</div> -->
